/**
 * Your classes, from Canvas.
 *
 * This used to be sample data lifted from the mockup. It is now empty until
 * the Canvas API answers, which means the sidebar is genuinely empty before
 * sign-in rather than showing somebody else's biology homework.
 *
 * Notes and flashcard sets have nowhere to come from yet, so every class
 * arrives with none of either and the screens show their empty states. That
 * is honest: Canvas knows what you are enrolled in, and knows nothing about
 * the notes you have not taken.
 *
 * The array identity is kept across a refresh — `length = 0` and push rather
 * than reassignment — because screens.js holds an index into it and imports
 * the binding directly.
 */

/** Stable per-course colours, so a class is the same colour every load. */
const PALETTE = [
  '#ff563c', '#34c759', '#0a84ff', '#ff9f0a',
  '#bf5af2', '#ff375f', '#5ac8fa', '#ffd60a',
];

export const CLASSES = [];

/** A number from a course id that does not move between sessions. */
function colourFor(id) {
  const text = String(id ?? '');
  let sum = 0;
  for (let i = 0; i < text.length; i += 1) sum = (sum * 31 + text.charCodeAt(i)) >>> 0;
  return PALETTE[sum % PALETTE.length];
}

/**
 * Canvas courses in, the shape the screens already render out.
 *
 * `code` is used for the subtitle because Canvas course names are often
 * friendly and duplicated across terms, while the code carries the term.
 */
export function fromCanvasCourses(courses) {
  return (courses ?? []).map((course) => ({
    id: course.id,
    name: course.name || course.code || 'Untitled course',
    meta: course.code || '',
    color: colourFor(course.id),
    // Nothing to be unread about: Canvas is not telling us about new material
    // here, only which courses exist.
    unread: 0,
    notes: [],
    sets: [],
  }));
}

/** Swap the contents without swapping the array. */
export function replaceClasses(next) {
  CLASSES.length = 0;
  CLASSES.push(...next);
  return CLASSES;
}
